export const ActionTextStyles = ({theme: {fonts, colors, icons}}) => {
  return {
    text: {
      ...fonts.BODY2,
      color: colors.INFORMATION_HIGH,
    },
  };
};
